/*
 * Script-Pfad herausfinden, in welchem sich jQuery befindet
 * Die muss dynamisch erfolgen, da man durch die Mehrsprachigkeit sich eine Ebene tiefer befinden kann!
 */
const JsPath = $('script[src*=\'bundle\']').first().attr('src').split('?')[0].split('/generated/').slice(0, -1).join('/') + '/';

export default JsPath;